import { all, put, takeLatest } from 'redux-saga/effects';
import {
  getErrorsFulfilled,
  getErrorsRequest,
  clearFieldsErrors,
  clearFieldsErrorsFulfilled,
} from './actions';

function* getErrorsRequestSaga({ payload }) {
  return yield put(getErrorsFulfilled(payload));
}

function* clearFieldsErrorsSaga() {
  return yield put(clearFieldsErrorsFulfilled());
}

export default all([
  takeLatest(getErrorsRequest, getErrorsRequestSaga),
  takeLatest(clearFieldsErrors, clearFieldsErrorsSaga),
]);
